import { render, staticRenderFns } from "./PageDeveloping.vue?vue&type=template&id=d54ae956"
import script from "./PageDeveloping.vue?vue&type=script&lang=ts"
export * from "./PageDeveloping.vue?vue&type=script&lang=ts"
import style0 from "./PageDeveloping.vue?vue&type=style&index=0&id=d54ae956&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports